// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__EUYtZ","center":"Loading_center___jh5r"};